import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pa-6",attrs:{"fluid":""}},[_c(VRow,[(!_vm.noColumn)?_c(VCol,{attrs:{"cols":"12"}},[_vm._t("default")],2):_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }